module.exports = __webpack_public_path__ + "static/AzoSans-Bold-c40403d3bad9e412119ff1c07f85f23b.woff2";